;(function () {
  'use strict'

  angular
    .module('deskfy.core')
    .controller('HeaderSearchController', HeaderSearchController)

  /* @ngInject */
  function HeaderSearchController ($scope, $location, $rootScope, $state, $q, $stateParams, CONSTANTS, Utils, ModalService, HeaderFilterService) {
    $scope.searchTerm = ''
    $scope.autoCompleteItems = []
    $scope.currentPage = $state.current.name
    $scope.placeholder = 'search'
    $scope.flags = {
      showFilter: false
    }

    const api = {
      _handleSuccessAutocomplete,
      _handleErrorAutocomplete,
      _dispatchSearchEvent,
      _handleSidebarTransition
    }
    this.getApi = () => api

    activate()

    function activate () {
      $scope.searchTerm = $stateParams.search

      $('.advanced-filter').dropdown()
    }

    const deregisterChangeSearchTerm = $rootScope.$on('changeSearchTerm', (e, term) => {
      $scope.searchTerm = term
    })

    const deregisterHeaderSearchPlaceholder = $rootScope.$on('headerSearch.placeholder', (e, placeholder) => {
      $scope.customPlaceholder = placeholder
    })

    const deregisterHeaderSearchClearText = $rootScope.$on('headerSearch.clearText', () => {
      $scope.searchTerm = ''
      $scope.autoCompleteItems = []
      $('.search-term-input').val('')
    })

    $scope.$on('$destroy', () => {
      deregisterChangeSearchTerm()
      deregisterHeaderSearchPlaceholder()
      deregisterHeaderSearchClearText()
    })

    $scope.showSearch = function () {
      $scope.currentPage = $state.current.name
      return $scope.currentPage === 'dam'
    }

    $scope.getThumbnailUrl = function (asset) {
      if (!asset || !asset.uuid) {

      }
    }

    $scope.handleSearchItemClick = function (asset) {}

    $scope.handleFilterSearchClick = function () {
      $scope.flags.showFilter = !$scope.flags.showFilter
    }

    $scope.handleSubmitSearch = function (event) {
      $scope.flags.showFilter = false
      $scope.autoCompleteItems = []
      const searchTerm = event?.detail?.value

      api._dispatchSearchEvent(searchTerm)

      if (!$rootScope.isDesktop) {
        api._handleSidebarTransition()
      }
    }

    $scope.handleChangeSearchTerm = function (event) {
      const searchTerm = event.detail.value

      if (!event) {
        $scope.autoCompleteItems = []
        return
      }

      if (searchTerm === '') {
        api._dispatchSearchEvent(searchTerm)
      }
    }

    $scope.handleSubmitArtsSearch = function (term, filters) {
      $scope.flags.showFilter = false
      api._dispatchSearchEvent(term, filters)
    }

    function _handleSuccessAutocomplete (items) {
      $scope.autoCompleteItems = items
    }

    function _handleErrorAutocomplete () {
      $scope.autoCompleteItems = []
    }

    function _dispatchSearchEvent (term, filters) {
      $rootScope.$broadcast('$damSearch', term, false, HeaderFilterService.getValue())
    }

    function _handleSidebarTransition () {
      $('.sidebar-menu-second-level').transition('slide down')
    }
  }
})()
